import {
  Card,
  Col,
  Row,
  Form,
  Tabs,
  Flex,
  Skeleton,
  Typography,
  Button,
  Empty,
  Table,
} from "antd";
import { useEffect, useState, useContext } from "react";
import ReportFilter from "../../components/reports/ReportFilter";
import DataTable from "../../components/common/DataTable";
import { DownloadOutlined } from "@ant-design/icons";
import useFetch from "../../hooks/useFetch";
import { IndexContext } from "../../context/IndexContext";
import dayjs from "dayjs";

var isoWeek = require("dayjs/plugin/isoWeek");

dayjs.extend(isoWeek);

export default function OverviewReportPage() {
  const { authenticationState, siteSelected } = useContext(IndexContext);

  const { Title } = Typography;
  const { TabPane } = Tabs;

  const [filterForm] = Form.useForm();
  const [filterValues, setFilterValues] = useState(null);

  // ------ state related to report table tab -------------------
  // device label selected in ReportFilter form
  const [deviceLabelSelected, setDeviceLabelSelected] = useState([]);
  // tab names
  const [tabName, setTabName] = useState([]);
  // tab items for selected device
  const [items, setItems] = useState([]);

  const [fetchWrapper] = useFetch();
  const [loading, setLoading] = useState(false);

  // picker type for From and To, it's also used to determine what column name for the table
  const [pickerType, setPickerType] = useState(null);

  // report data
  const [reportData, setReportData] = useState([]);

  const columns = [
    {
      title:
        pickerType === "date"
          ? "Time"
          : pickerType === "week"
          ? "Week"
          : pickerType === "month"
          ? "Month"
          : pickerType === "half_and_hour"
          ? "Time"
          : "Year",
      align: "left",
      dataIndex: "date_time",
      key: "date_time",
      width: 110,
      colSpan: 2,
      onCell: (_, index) => ({
        colSpan: 2,
      }),
    },
    {
      title: "",
      colSpan: 0,
      align: "left",
      dataIndex: "date_time",
      key: "date_time",
      width: 100,
      render: (_, row) => {
        console.log("render", _);
      },
      onCell: (_, index) => {
        console.log("", _);
        return {
          colSpan: 0,
        };
      },
    },
    {
      title: "Avg Line Voltage (V)",
      dataIndex: "line_voltage",
      key: "line_voltage",
      width: 200,
    },
    {
      title: "Avg Phase Voltage (V)",
      dataIndex: "phase_voltage",
      key: "phase_voltage",
      width: 200,
    },
    {
      title: "Avg Current (A)",
      dataIndex: "current",
      key: "current",
      width: 200,
    },
    {
      title: "Avg Power Factor",
      dataIndex: "power_factor",
      key: "power_factor",
      width: 200,
    },
    {
      title: "Active Energy Consumption (kWh)",
      dataIndex: "active_energy_consumption",
      key: "active_energy_consumption",
      width: 300,
    },
    {
      title: "Reactive Energy Consumption (kVArH)",
      dataIndex: "reactive_energy_consumption",
      key: "reactive_energy_consumption",
      width: 300,
    },
  ];

  const applyFilter = (value) => {
    setFilterValues(value);
  };

  /* API to get report data */
  function getReportData(device_selected) {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "reports/getReportData",
      body: {
        site_id: siteSelected,
        date_type: filterValues.report_type,
        start_date:
          filterValues.report_type === "date"
            ? filterValues.start.startOf("day").format("YYYY-MM-DD HH:mm:ss")
            : filterValues.report_type === "week"
            ? filterValues.start
                .startOf("isoWeek")
                .format("YYYY-MM-DD HH:mm:ss")
            : filterValues.report_type === "month"
            ? filterValues.start.startOf("month").format("YYYY-MM-DD HH:mm:ss")
            : filterValues.report_type === "half_and_hour"
            ? filterValues.start.startOf("day").format("YYYY-MM-DD HH:mm:ss")
            : filterValues.start.startOf("year").format("YYYY-MM-DD HH:mm:ss"),
        end_date:
          filterValues.report_type === "date"
            ? filterValues.end.endOf("day").format("YYYY-MM-DD HH:mm:ss")
            : filterValues.report_type === "week"
            ? filterValues.end.endOf("isoWeek").format("YYYY-MM-DD HH:mm:ss")
            : filterValues.report_type === "month"
            ? filterValues.end.endOf("month").format("YYYY-MM-DD HH:mm:ss")
            : filterValues.report_type === "half_and_hour"
            ? filterValues.end.startOf("day").format("YYYY-MM-DD HH:mm:ss")
            : filterValues.end.endOf("year").format("YYYY-MM-DD HH:mm:ss"),
        device_view: filterValues.device_view,
        devices: device_selected,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);
        if (fetch_output.status === true) {
          setItems(fetch_output.report_data);
          console.log(fetch_output.report_data);
          // setReportData(fetch_output.report_data);
        }
      },
    });
  }

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  function downloadReportData() {
    fetchWrapper({
      endpoint_url: "reports/downloadReportData",
      json_output: false,
      body: {
        report_data: items,
        date_type: filterValues.report_type,
      },
      onSuccess: (response) => {
        if (response.headers.get("content-type") === "application/json") {
          response.json().then((data) => {
            if (data.error) {
              // messageApi.open({
              //     type: "error",
              //     content: data.error || "Failed to download report data file"
              // });
              console.log("");
            } else {
              // messageApi.open({
              //   type: "error",
              //   content: "Failed to download report data file"
              // });
              console.log("");
            }
          });
        } else {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Report_Data_" + formatDate(new Date()) + ".xlsx"; // Ensure the file has the right extension
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          });
        }
      },
      onResponseError: (err) => {
        console.log("");
      },
    });
  }

  // once user submits ReportFilter form, set tab names
  useEffect(() => {
    if (filterValues) {
      setTabName(deviceLabelSelected);
    }
  }, [filterValues]);

  // once tab names are set (and if user submits ReportFilter form), set tab items and get report data
  useEffect(() => {
    if (filterValues && tabName.length > 0) {
      getReportData(filterValues.device);
    }
  }, [filterValues, tabName]);

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <ReportFilter
            form={filterForm}
            applyFilter={applyFilter}
            pickerType={pickerType}
            setPickerType={setPickerType}
            setDeviceLabelSelected={setDeviceLabelSelected}
          />
        </Col>
        <Col span={24}>
          <Card styles={{ body: { minHeight: 400 } }}>
            <Flex
              justify="space-between"
              align="center"
              className="mb-2"
              wrap={true}
              gap={8}
            >
              <Title level={5} className="m-0">
                REPORT
              </Title>
              <Button
                icon={<DownloadOutlined />}
                onClick={() => {
                  downloadReportData();
                }}
              ></Button>
            </Flex>

            {loading ? (
              <div style={{ height: 520 }}>
                <Skeleton />
              </div>
            ) : (
              <>
                {items.length > 0 ? (
                  <div>
                    <Tabs type="card">
                      {items.map((each_item) => {
                        return (
                          <TabPane tab={each_item.key} key={each_item.key}>
                            <DataTable
                              size="small"
                              table_column={columns}
                              table_data={each_item.data}
                              scroll_width={700}
                              tableWrapperViewportHeight={0.5}
                              defaultPageSize={10}
                              summary={() => {
                                return (
                                  <Table.Summary>
                                    <Table.Summary.Row
                                      style={{
                                        background:
                                          "var(--ant-table-header-bg)",
                                      }}
                                    >
                                      <Table.Summary.Cell
                                        index={0}
                                        colSpan={1}
                                        rowSpan={each_item.summary?.length + 1}
                                      >
                                        <Typography.Text strong>
                                          Summary
                                        </Typography.Text>
                                      </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                    {each_item.summary?.map((row, x) => (
                                      <Table.Summary.Row
                                        key={x}
                                        style={{
                                          background:
                                            "var(--ant-table-header-bg)",
                                        }}
                                      >
                                        {Object.keys(row).map((col, y) => (
                                          <Table.Summary.Cell
                                            index={y}
                                            key={y}
                                            colSpan={1}
                                          >
                                            <Typography.Text strong>
                                              {row[col]}
                                            </Typography.Text>
                                          </Table.Summary.Cell>
                                        ))}
                                      </Table.Summary.Row>
                                    ))}
                                  </Table.Summary>
                                );
                              }}
                            />
                          </TabPane>
                        );
                      })}
                    </Tabs>
                  </div>
                ) : (
                  <Flex justify="center" align="center" style={{ height: 400 }}>
                    <Empty />
                  </Flex>
                )}
              </>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
}
